import React from 'react';
import { Lightbulb, LightbulbOff } from 'lucide-react';
import { useHints } from '../../context/HintsContext';
import {
  HINTS_ARIA_OFF,
  HINTS_ARIA_ON,
  HINTS_LABEL,
} from '../../utils/hintCopy';
import './HintsToggle.css';

export default function HintsToggle({ className = '' }) {
  const { ready, hintsOn, toggleHints } = useHints();

  if (!ready) return null;

  const aria = hintsOn ? HINTS_ARIA_ON : HINTS_ARIA_OFF;
  const Icon = hintsOn ? Lightbulb : LightbulbOff;

  return (
    <button
      type="button"
      className={`hints-toggle${hintsOn ? ' hints-toggle--on' : ''}${className ? ` ${className}` : ''}`}
      aria-pressed={hintsOn}
      aria-label={aria}
      title={aria}
      onClick={toggleHints}
    >
      <Icon size={18} strokeWidth={2} aria-hidden className="hints-toggle__icon" />
      <span className="hints-toggle__word">{HINTS_LABEL}</span>
    </button>
  );
}
